// ----------------------------------------------------------------------

export function skeleton(theme) {
  return {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.border.primaryBlack3,
        },
        rounded: {
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
  };
}
